import { render, staticRenderFns } from "./HomepageStatus.vue?vue&type=template&id=22dea046&"
import script from "./HomepageStatus.vue?vue&type=script&lang=js&"
export * from "./HomepageStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports